import * as types from "../constants/ActionTypes";

export const initialState = {
  loading: true,
  userGranted: undefined,
  roleGranted: undefined,
  userList: undefined,
  roleList: undefined
};

function grants(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CURRENT_NOTE_GRANTS:
      const { grants } = action;
      return {
        ...state,
        loading: false,
        userGranted: grants.userGranted,
        roleGranted: grants.roleGranted,
        userList: grants.userList,
        roleList: grants.roleList
      };
    case types.RESET_GRANTS:
      return initialState;
    default:
      return state;
  }
}

export default grants;
